





























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Title from "./title.vue";
import SubTitle from "./title-sub.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private index: any;
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private danwei: any = [
    "克",
    "粒",
    "枚",
    "片",
    "只",
    "个",
    "尺",
    "杯",
    "束",
    "合",
    "升",
    "钱",
    "两",
    "包",
    "支",
    "盒",
    "丸",
  ];
  private fuyong: any = [
    "日一剂，水煎服",
    "日一剂，冲服",
    "日一剂，灌肠",
    "日一剂，外用",
    "日一剂，热敷",
  ];
  private jiliangdanwei: any = [
    "片/次",
    "支/次",
    "包/次",
    "丸/次",
    "袋/次",
    "克/次",
    "毫克/次",
    "毫升/次",
  ];
  private get c() {
    return JSON.parse(JSON.stringify(this.content));
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  /**
   * @description 删除一个
   */
  private deleteOne(i: any) {
    this.c["value"]["饮片"].splice(i, 1);
    if (this.c["value"]["饮片"].length === 0) {
      this.c["value"]["饮片"].push({});
    }
    this.$emit("update", this.c);
  }
  /**
   * @description 增加一个
   */
  private addOne() {
    this.c["value"]["饮片"].push({});
    this.$emit("update", this.c);
  }
  private valueChange(e: any) {
    if (this.source === "dialog") {
      this.$emit("updateDialog", this.c);
    } else {
      this.$emit("update", this.c);
    }
  }
}
